import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginWithEmailPassword } from "../../redux/action";
import { Link, useNavigate ,useParams} from "react-router-dom";
//import "./index.css";
import bgAuthOverlayIcon from '../../assets/images/bg-auth-overlay 1.svg';
import incaLogoDark from '../../assets/images/Inca-Logo-Dark.svg'
import incaLogo from '../../assets/images/Inca 1.svg'


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logo from '../../assets/images/Inca-Logo-WHite 1.svg'
import {SUPPORT_PHONE_RAW} from "../../constants/defaultValues";
import {formatPhoneNumber} from "react-phone-number-input";


const Login = () => {
  
  const dispatch = useDispatch();
  const authUser=useSelector((state)=>state.authUser)
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const store = useSelector((state) => state);

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  

  
  const handleSubmit = (e) => {
  
   e.preventDefault();
    dispatch(loginWithEmailPassword({ email, password }));

  if(authUser.login){
     navigate("/")
    }
  };


  useEffect(()=>{
    
    if(authUser.error!=="")
    toast(authUser.error, {
      position: toast.POSITION.TOP_RIGHT,
      className: 'foo-bar'
    });
  },[authUser.isLoading])

useEffect(() => {
    if (authUser?.login?.status === "ok") {
      navigate("/");
      console.log("Status OK");
    } else {
      console.log("Not ok");
    }
  }, [authUser?.login?.status]);

  return (
    <>
     <div className="row gx-0">
      <ToastContainer autoClose={4000}/>
        <div
            className="col-md-8 col-lg-8 col-sm-12 col-xs-12 position-relative login-image-section d-flex justify-content-center align-items-center mobile-display-none">
            <img src={bgAuthOverlayIcon} className="img-fluid position-absolute top-0"/>
            <img src={logo} className="img-fluid"/>
        </div>
        <div className="col-md-4 col-lg-4 col-sm-12 col-xs-12 mobile-overflow-scroll mb-5">
            <div className="d-flex justify-content-center">
                <div className="login-container">
                    <div>
                        <img src={incaLogo} width="50" height="50" className="img-fluid"/>

                        <p className="head mt-3">Every call is an opportunity. INCA works so you can rest.</p>
                        <p className="text">Please use your credentials to login.
                            If you are not a member, please register.
                        </p>
                        <p className="text">
                            If you need any assistance please email us at info@getinca.com or call us at{" "}
                            <a href={`tel:${SUPPORT_PHONE_RAW}`}>{formatPhoneNumber(SUPPORT_PHONE_RAW)}</a>. Thank you!
                        </p>
                    </div>
                    <div className="form-section mt-3">
                        <p className="head">Login</p>
                        <div className="input-group mt-3 mb-3">
                            <input type="email" value={email} onChange={handleEmailChange} className="form-control input-border" placeholder="Email"
                                aria-label="Email"/>
                        </div>
                        <div className="input-group mb-3">
                            <input type="password" value={password} onChange={handlePasswordChange} className="form-control input-border" placeholder="Password"
                                aria-label="Password"/>
                        </div>
                        <div className="d-flex justify-content-between">
                            <button className="btn-light btn-sm btn"><Link to='/forgot-password'> Forgot Password</Link></button>
                            <button className="primary-btn" onClick={handleSubmit}>LOGIN</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    </>
  );
};

export default Login;
